import { Box, css, Grid } from '@mui/material'
import { useEffect, useState } from 'react'

import { useMQ } from '../hooks/useMQ'
import { protocolService } from '../services/protocol'
import { formatMoney } from '../utils/common'
import { BlurBox } from './BlurBox'
import { HumaScrollAnimation } from './HumaScrollAnimation'

export function ProtocolStats() {
  const { isSmSize } = useMQ()
  const [totalTransactionVolume, setTotalTransactionVolume] =
    useState<string>('--')
  const [activeLiquidity, setActiveLiquidity] = useState<string>('--')

  useEffect(() => {
    const getTotalTransactionVolume = async () => {
      try {
        const totalTransactionVolume =
          await protocolService.getTotalTransactionVolume()
        setTotalTransactionVolume(formatMoney(totalTransactionVolume))
      } catch (e) {
        setTotalTransactionVolume('--')
      }
    }
    getTotalTransactionVolume()
  }, [])

  useEffect(() => {
    const getActiveLiquiidty = async () => {
      try {
        const activeLiquidity = await protocolService.getActiveLiquiidty()
        setActiveLiquidity(formatMoney(activeLiquidity))
      } catch (e) {
        setActiveLiquidity('--')
      }
    }
    getActiveLiquiidty()
  }, [])

  const styles = {
    statsContainer: css`
      background: #121212;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 24px;
      background: #121212;
      border-radius: 16px;
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      justify-content: space-evenly;
      column-gap: 40px;
    `,
    statsItem: css`
      height: ${isSmSize ? '190px' : '160px'};
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-bottom: ${isSmSize ? '0px' : '0px'};
      margin-right: ${isSmSize ? '0px' : '32px'};
      margin-left: ${isSmSize ? '0px' : '32px'};
      text-align: center;
      background: ${isSmSize ? 'rgba(0, 0, 0, 0.7) !important' : 'none'};
    `,
    statsTitle: css`
      font-family: 'Red-Hat-Display';
      padding: 4px 18px;
      font-weight: ${isSmSize ? '700' : '700'};
      color: #b8b8b8;
      font-size: ${isSmSize ? '16px' : '20px'};
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 160%;
      letter-spacing: 0.15px;
      white-space: ${isSmSize ? 'normal' : 'nowrap'};
    `,
    statsValue: css`
      font-weight: 700;
      color: ${isSmSize ? '#CECECE' : '#fff'};
      font-size: ${isSmSize ? '32px' : '48px'};
      line-height: 116.7%;
      margin-top: 18px;
    `,
    divider: css`
      border-color: #313131;
      margin-bottom: 20px;
      margin-right: 0px;
      margin-left: 0px;
    `,
    tooltipButton: css`
      svg {
        width: 16px;
        height: 16px;
        margin-top: -12px;
      }
    `,
  }

  return (
    <HumaScrollAnimation>
      <Box marginTop='240px'>
        {!isSmSize && (
          <Box css={styles.statsContainer} display='flex' flexDirection='row'>
            <Box css={styles.statsItem}>
              <Box css={styles.statsTitle}>Total Transaction Volume</Box>
              <Box css={styles.statsValue}>{totalTransactionVolume}</Box>
            </Box>
            <Box css={styles.statsItem}>
              <Box css={styles.statsTitle}>Total Active Liquidity</Box>
              <Box css={styles.statsValue}>{activeLiquidity}</Box>
            </Box>
            <Box css={styles.statsItem}>
              <Box css={styles.statsTitle}>Real Yield</Box>
              <Box css={styles.statsValue}>10%</Box>
            </Box>
            <Box css={styles.statsItem}>
              <Box css={styles.statsTitle}>Rewards Up To</Box>
              <Box css={styles.statsValue}>12.7x</Box>
            </Box>
          </Box>
        )}

        {isSmSize && (
          <Grid container spacing={2}>
            <Grid item xs={6} height='100%'>
              <BlurBox extraStyles={styles.statsItem}>
                <Box css={styles.statsTitle}>Total Transaction Volume</Box>
                <Box css={styles.statsValue}>{totalTransactionVolume}</Box>
              </BlurBox>
            </Grid>
            <Grid item xs={6} height='100%'>
              <BlurBox extraStyles={styles.statsItem}>
                <Box css={styles.statsTitle}>Total Active Liquidity</Box>
                <Box css={styles.statsValue}>{activeLiquidity}</Box>
              </BlurBox>
            </Grid>
            <Grid item xs={6} height='100%'>
              <BlurBox extraStyles={styles.statsItem}>
                <Box css={styles.statsTitle}>Real Yield</Box>
                <Box css={styles.statsValue}>10%</Box>
              </BlurBox>
            </Grid>
            <Grid item xs={6} height='100%'>
              <BlurBox extraStyles={styles.statsItem}>
                <Box css={styles.statsTitle}>Rewards Up To</Box>
                <Box css={styles.statsValue}>12.7x</Box>
              </BlurBox>
            </Grid>
          </Grid>
        )}
      </Box>
    </HumaScrollAnimation>
  )
}
